import {
	types, flow, applySnapshot, Instance, getParent,
} from 'mobx-state-tree';

import {
	getServiceTemplates,
} from '@common/api/serviceTemplates';

import ServiceTemplate from './ServiceTemplate';

const ServiceTemplates = types
	.model('ServiceTemplates', {
		data: types.optional(types.array(ServiceTemplate), []),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get current() {
			// @ts-ignore-next-line
			const serviceId = getParent(self).services.current.id;
			return self.data.find((serviceTemplate) => serviceTemplate.service.id === serviceId);
		},
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getServiceTemplates();
				applySnapshot(self.data, result);
			} catch (e) {
				console.error(e);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default ServiceTemplates;

export interface IServiceTemplatesModel extends Instance<typeof ServiceTemplates> {}
